// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

// List of used local storage keys
export const LOCAL_STORAGE_THEME_KEY = 'theme';
export const LOCAL_STORAGE_EXPERIMENTS_KEY = 'experiments';
export const LOCAL_STORAGE_CALL_ID_HISTORY_KEY = 'callIdHistory';
export const REMEMBER_PREFERENCE_KEY = 'rememberMobilePreference';
export const CONTINUE_BROWSER_PREFERENCE = 'continueInBrowser';
export const OPEN_MOBILE_APP_PREFERENCE = 'openMobileApp';

export const saveToLocalStorage = (key: string, value: string): void => {
  if (typeof window.localStorage !== 'undefined') {
    window.localStorage.setItem(key, value);
  }
};

export const saveJsonToLocalStorage = (key: string, value: Record<string, unknown> | unknown[]): void =>
  saveToLocalStorage(key, JSON.stringify(value));

export const getFromLocalStorage = (key: string): string | undefined => {
  if (typeof window.localStorage !== 'undefined') {
    return window.localStorage.getItem(key) ?? undefined;
  }
  return undefined;
};

export const getJsonFromLocalStorage = <T>(key: string): T | undefined => {
  const value = getFromLocalStorage(key);
  if (value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error(`Error parsing ${key} from local storage`, e);
    }
  }
  return undefined;
};

export const removeFromLocalStorage = (key: string): void => {
  if (typeof window.localStorage !== 'undefined') {
    window.localStorage.removeItem(key);
  }
};

export const clearLocalStorage = (): void => {
  if (typeof window.localStorage !== 'undefined') {
    window.localStorage.clear();
  }
};
